import { useEffect, useState } from 'react';
import tailwindUrl from './dashboard.css?url';

const useTW: () => boolean = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Remove prerendered landing page styles to prevent conflicts
    const prerendered = document.getElementById('prerendered-styles');
    if (prerendered) {
      prerendered.remove();
    }

    const existingLink = document.getElementById('scoped-tailwind');
    if (existingLink) {
      setIsLoaded(true);
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = tailwindUrl;
    link.id = 'scoped-tailwind';

    link.onload = () => setIsLoaded(true);
    link.onerror = () => setIsLoaded(true); // Fail gracefully

    document.head.appendChild(link);

    return () => {
      document.getElementById('scoped-tailwind')?.remove();
    };
  }, []);

  return isLoaded;
};

export default useTW;
